<script lang="ts">
    const { title, description, children } = $props();
</script>

<div class="flex-1 p-6 md:p-10 rounded-2xl bg-white">
    <div class="relative h-full flex flex-col gap-6 md:gap-18 justify-between">
        <div class="space-y-2 md:space-y-6">
            <h4>{title}</h4>
            <p class="text-lg text-gray-500">
                {description}
            </p>
        </div>
        {@render children?.()}
    </div>
</div>
